import React from 'react';
import { Time } from './Time';
import { formatAsLocalDate } from './util';

interface LocalDateProps {
  /**
   * The date to be displayed. Can be a valid date string parseable by Date.parse() or a Unix timestamp in milliseconds.
   */
  date: string | number;

  /**
   * Optional CSS class name to apply to the time element.
   */
  className?: string;
}

/**
 * LocalDate component displays a date in the "Jan 15, 2025" format.
 * Mimics the formatAsLocalDate utility function.
 */
export const LocalDate: React.FC<LocalDateProps> = ({ date, className }) => {
  const timestamp = typeof date === 'string' ? Date.parse(date) : date;

  const formattedDate = formatAsLocalDate(timestamp);

  return (
    <Time date={formattedDate} className={className}>
      {formattedDate}
    </Time>
  );
};
